import React from 'react';
import { Card } from './ui/card';
import { CheckCircle } from 'lucide-react';
import { aboutData } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4">
              {aboutData.title}
            </h2>
            <div className="w-24 h-1 bg-[#2d8b8b] mx-auto mb-6"></div>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
              {aboutData.description}
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
            {aboutData.highlights.map((highlight, index) => (
              <Card key={index} className="p-6 text-center hover:shadow-lg transition-all duration-300 border-t-4 border-[#2d8b8b]">
                <div className="w-14 h-14 bg-[#2d8b8b]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="w-7 h-7 text-[#2d8b8b]" />
                </div>
                <h3 className="text-base font-semibold text-[#1e3a5f]">
                  {highlight}
                </h3>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
